<!-- Add Entities List - Flutter AddEntitiesList equivalent -->
<!-- Height: 52px, horizontal scroll, buttons with icon LEFT of text -->
<div class="add-entities-container" (click)="$event.stopPropagation()">
  <div class="add-entities-scroll"
       #scrollContainer
       (mousedown)="onMouseDown($event)"
       (mouseup)="onMouseUp()"
       (mousemove)="onMouseMove($event)"
       (mouseleave)="onMouseLeave()">
    @for (item of addEntityItems(); track item.id) {
      <!-- More button - icon only -->
      @if (item.id === 'more') {
        <button class="add-entity-btn more-btn"
                (click)="togglePremiumFeatures($event); $event.stopPropagation()"
                [attr.aria-label]="getLabel(item.labelKey)">
          <app-svg [name]="item.icon"
                   [color]="ss.theme().color12"
                   style="width: 18px; height: 18px;">
          </app-svg>
        </button>
      } @else {
        <!-- Regular buttons with icon and text -->
        <button class="add-entity-btn"
                [class.premium]="item.isPremium"
                (click)="onItemClick(item, $event); $event.stopPropagation()"
                [attr.aria-label]="getLabel(item.labelKey)" >
          <app-svg [name]="item.icon"
                   [color]="item.isPremium ? ss.theme().color12 : ss.theme().color12"
                   style="width: 14px; height: 14px;">
          </app-svg>
          <span class="label">{{ getLabel(item.labelKey) }}</span>
          <!-- @if (item.isPremium) {
            <app-svg name="lock"
                     [color]="ss.theme().color26"
                     style="width: 12px; height: 12px; margin-left: 4px;">
            </app-svg>
          } -->
        </button>
      }
    }
  </div>
</div>
